export default {
  methods: {
    validateStatus({ field, serverKey, label }) {
      if (field === undefined) return {};

      let validationRules = [];

      validationRules = {
        invalid: field.$invalid,
        dirty: field.$dirty,
        errors: [],
      };

      Object.entries(field.$params).forEach((key) => {
        const type = key[0];
        const params = field.$params;
        validationRules.errors.push({
          type,
          status: field[type],
          message: this.getErrorMessage(params, label, type),
        });
      });

      if (this.serverValidationErrors[serverKey]) {
        validationRules.errors.push({
          type: 'serverValidation',
          status: false,
          message: this.serverValidationErrors[serverKey],
        });
      }

      return validationRules;
    },
    getErrorMessage(params, formField, type) {
      const messageFunction = this.lang.formValidation[type];

      if (typeof messageFunction !== 'function') {
        console.error('Unrecognised validation message', { params, formField, type });
        return '';
      }

      return messageFunction(formField, params[type]);
    },
    validateBlur({ field, serverKey }) {
      if (field === undefined) return;

      field.$touch();
      this.serverValidationErrors[serverKey] = null;
    },
  },
};
